import type { OrgData } from "@p0security/shared/types/tenant/index";
import { useEffect, useState } from "react";

import type { TenantData } from "../types/auth";
import { slugToTenant } from "../util";

export const useTenantResolution = (orgSlug?: string) => {
  const [tenant, setTenant] = useState<TenantData>({ state: "loading" });
  const [orgData, setOrgData] = useState<OrgData | undefined>();

  useEffect(() => {
    let isCanceled = false;
    if (!orgSlug) return;

    slugToTenant(orgSlug)
      .then((tenantAuth) => {
        if (!isCanceled) {
          if (tenantAuth) {
            setOrgData(tenantAuth);
            setTenant({ state: "found", ...tenantAuth });
          } else {
            setTenant({ state: "not_found" });
          }
        }
      })
      .catch((err) => {
        if (!isCanceled) {
          alert(err);
          setTenant({ state: "not_found" });
        }
      });

    return () => {
      isCanceled = true;
    };
  }, [orgSlug]);

  return { tenant, orgData };
};
